import brandPortalOrdersbrandOrderTokenOrderFulfilment from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/order-fulfilment";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var DiscrepancyInPayoutTotalIA = function DiscrepancyInPayoutTotalIA(_ref) {
  var brandOrder = _ref.brandOrder;
  if (brandOrder) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "XAYTV2",
      defaultMessage: [{
        "type": 0,
        "value": "Voordat je contact opneemt met ons ondersteuningsteam, raden we je aan om je uitbetaling nog een keer te controleren, met de volgende gegevens in gedachten:"
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
      step: 1
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "meI9PQ",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Controleer je uitbetaling"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": bekijk de volledige berekening op de "
      }, {
        "children": [{
          "type": 0,
          "value": "bestellingspagina"
        }],
        "type": 8,
        "value": "OrderDetailLinkFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        },
        OrderDetailLinkFormatting: function OrderDetailLinkFormatting(chunks) {
          var _brandOrder$brand_ord, _brandOrder$brand_ord2;
          return orderDetailLinkFormatting(chunks, (_brandOrder$brand_ord = (_brandOrder$brand_ord2 = brandOrder.brand_order) === null || _brandOrder$brand_ord2 === void 0 ? void 0 : _brandOrder$brand_ord2.token) !== null && _brandOrder$brand_ord !== void 0 ? _brandOrder$brand_ord : "");
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 2
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "/23Rwc",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Controleer op retourzendingen of aanpassingen"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": retourzendingen, verzendaanpassingen of promotionele kortingen kunnen van invloed zijn op je uitbetaling. Deze worden gespecificeerd in je transactiegegevens. Als artikelen als beschadigd of ontbrekend worden opgegeven, worden ze in mindering gebracht op de uitbetaling van de bestelling waar ze bij horen."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 3
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "d6yt+p",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Houd rekening met commissies"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": de commissies worden berekend op basis van het subtotaal van de bestelling."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 4
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "lEvLnb",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Houd rekening met verwerkingskosten"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": de betalingsverwerkingskosten zijn van invloed op het uiteindelijke uitbetalingsbedrag. De kostenstructuur hangt af op de uitbetalingsoptie die je hebt gekozen."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 5
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "GgW3sY",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Vraag om opheldering"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": als je je nog steeds zorgen maakt of als er iets niet in orde lijkt te zijn met je uitbetaling, aarzel dan niet om contact met ons op te nemen."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })))));
  }
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "omcjTV",
    defaultMessage: [{
      "type": 0,
      "value": "Voordat je contact opneemt met ons ondersteuningsteam, raden we je aan om je uitbetaling nog een keer te controleren, rekening houdend met de volgende punten:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "IzZ4Mb",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Bekijk je uitbetaling"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": bekijk de volledige berekening voor een specifieke bestelling door naar de Bestellingen te gaan en vervolgens op de bestellingspagina te klikken. Scrol naar de sectie Je bent uitbetaald en selecteer Uitbetalingsoverzicht bekijken. Daar vind je een gedetailleerd overzicht van de uitbetaling."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "SWyxt7",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Controleer op retourzendingen of aanpassingen"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": retourzendingen, verzendaanpassingen of promotionele kortingen kunnen van invloed zijn op je uitbetaling. Deze staan gespecificeerd in je uitbetalingsoverzicht. Als artikelen als beschadigd of ontbrekend worden opgegeven, worden ze in mindering gebracht op de uitbetaling van de bestelling waar ze bij horen."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "OGBrmv",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Houd rekening met commissies"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": de commissies worden berekend op basis van het subtotaal van de bestelling."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "mU015p",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Let op verwerkingskosten"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": de betalingsverwerkingskosten zijn van invloed op het uiteindelijke uitbetalingsbedrag. De kostenstructuur hangt af op de uitbetalingsoptie die je hebt gekozen."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 5
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "xUp5Oe",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Vraag om opheldering"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": als je je nog steeds zorgen maakt of als er iets niet in orde lijkt te zijn met je uitbetaling, aarzel dan niet om contact met ons op te nemen."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))));
};
var orderDetailLinkFormatting = function orderDetailLinkFormatting(chunks, brandOrderToken) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrdersbrandOrderTokenOrderFulfilment(brandOrderToken, {
      sync: "true"
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};